export default __webpack_public_path__ + "static/media/sam-and-karen-360-bridge.e157a442.jpeg";